import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';
import PropTypes from 'prop-types';

const WorkFileTypeDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedWorkFileType, refreshData }) => {
    const initialWorkFileTypeData = {
        id: '',
        title: '',
    };

    const [workFileTypeData, setWorkFileTypeData] = useState(initialWorkFileTypeData);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isOpen) {
            if (mode === 'modify' && selectedWorkFileType) {
                setWorkFileTypeData({ ...initialWorkFileTypeData, ...selectedWorkFileType });
            } else {
                resetForm();
            }
            setErrors({});
        }
    }, [mode, selectedWorkFileType, isOpen]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let processedValue = value;

        if (name === 'title' && typeof processedValue === 'string') {
            processedValue = processedValue.toLocaleUpperCase('tr-TR');
        }

        setWorkFileTypeData(prevData => ({ ...prevData, [name]: processedValue }));

        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
        }
    };

    const validateForm = () => {
        const validationErrors = {};

        if (!workFileTypeData.title?.trim()) {
            validationErrors.title = 'İş Dosyası tipi başlığı zorunludur.';
        } else if (workFileTypeData.title.trim().length < 2) {
            validationErrors.title = 'Başlık en az 2 karakter olmalıdır.';
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const resetForm = () => {
        setWorkFileTypeData(initialWorkFileTypeData);
        setErrors({});
    };

    const handleCancel = () => {
        resetForm();
        toggle();
    };

    const handleOperation = async () => {
        if (!validateForm()) {
            toast.error('Lütfen formdaki hataları düzeltin.');
            const firstErrorKey = Object.keys(errors).find(key => errors[key]);
            if (firstErrorKey) document.getElementById(firstErrorKey)?.focus();
            return;
        }

        const payload = {
            title: workFileTypeData.title,
            ...(mode === 'modify' && selectedWorkFileType?.id && { id: selectedWorkFileType.id })
        };

        console.log("Sending Payload:", payload);

        try {
            await handleAddModifyOperation({
                apiEndpoint,
                selectedItem: mode === 'modify' ? { id: selectedWorkFileType?.id } : null,
                mode,
                data: payload,
                refreshDataCallback: refreshData,
                componentName: 'İş Dosyası Tipi',
            });
            toggle();
        } catch (error) {
            console.error("İş Dosyası Tipi operasyonu başarısız:", error);
        }
    };

    const getModalTitle = () => {
        return mode === 'add' ? 'İş Dosyası Tipi Ekle' : 'İş Dosyası Tipi Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="title">Tür Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={workFileTypeData.title || ''}
                            onChange={handleInputChange}
                            placeholder="İş Dosyası Türü Adı"
                            invalid={!!errors.title}
                        />
                        <FormFeedback>{errors.title}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleOperation}>
                    {getButtonLabel()}
                </Button>
                <Button color="secondary" onClick={handleCancel} className="ms-2">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

WorkFileTypeDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'modify']).isRequired,
    selectedWorkFileType: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default WorkFileTypeDataModal;
